var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceversion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    width: 40,
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4.668 2a2 2 0 0 0-1.926 1.459l-.435 1.548C2.37 5.003 2.436 5 2.5 5h2a2.5 2.5 0 0 1 2.502 2.5V12h5.915a2.08 2.08 0 0 0 2.003-2.643l-1.66-5.898A2 2 0 0 0 11.337 2H4.668Zm2.285 12a2.51 2.51 0 0 0 .05-.5V13h4.5a.5.5 0 1 1 0 1h-4.55ZM3.5 9.5a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5ZM1 7.5A1.5 1.5 0 0 1 2.5 6h2.001a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-2A1.5 1.5 0 0 1 1 13.5v-6ZM2.5 7a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h2.001a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceversion);
export default __webpack_public_path__ + "static/media/deviceversion.12e28a89e7293c2271d554d67e6df27c.svg";
export { ForwardRef as ReactComponent };